import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class StoreService {

    private settings = new BehaviorSubject<any[]>([]);

    constructor() {}

    get settings$(): Observable<any[]> {
        return this.settings.asObservable();
    }

    setSettings(newSettings: any[]): void {
        this.settings.next(newSettings);
    }

    getSettingByKey(key: string): Observable<string | undefined> {
        return this.settings$.pipe(
            map(settings => {
                const setting = settings.find(setting => setting.key === key);
                return setting ? setting.value : undefined;
            })
        );
    }
}
